module.exports = __webpack_public_path__ + "static/Grafika4@2x-2ef8bec1cce0850c3d69e17451fd53fc.png";